<script setup lang="ts">
    import { InputRow, Combobox, Select, DatePicker } from '@/components/ui/form';
    import { useI18n } from 'vue-i18n';
    import { useEmployeesInPayrollData } from '@/composables/useEmployeesInPayrollData';
    import { Payroll, Employee } from '@/types';
    // import { optionsYesNo } from '@/utils/form';
    // import { computed, watch } from 'vue';

    const props = defineProps<{
        form: any;
        payroll: Payroll;
        employees: Employee[];
    }>();

    const { t } = useI18n();

    const { employees: employeesInPayroll, isLoadingEmployees } = useEmployeesInPayrollData(
        props.payroll.id,
    );

    // const selectedEmployee = computed(() => {
    //     return props.employees.find((employee) => employee.id === props.form.employee_id);
    // });

    // const isTerminated = computed(() => {
    //     return selectedEmployee.value?.termination !== null;
    // });

    // watch(selectedEmployee, (newEmployee) => {
    //     if (newEmployee && newEmployee.termination) {
    //         props.form.termination_date = newEmployee.termination.termination_date;
    //     }
    // });
</script>

<template>
    <InputRow
        :form="form"
        name="employee_id"
        label="payrolls.remove_employee_from_payroll.select_employee"
    >
        <Combobox
            v-model="form.employee_id"
            :options="employeesInPayroll"
            :translate="false"
            :placeholder="t('payrolls.remove_employee_from_payroll.select_employee')"
            label-by="full_name"
            value-by="id"
            :loading="isLoadingEmployees"
            :show-remove-button="false"
        />
    </InputRow>
    <!-- <InputRow
        v-if="selectedEmployee && !isTerminated"
        :form="form"
        name="terminate"
        label="payrolls.remove_employee_from_payroll.terminate"
    >
        <Select
            v-model="form.terminate"
            :options="optionsYesNo"
            :translate="true"
        />
    </InputRow>
    <InputRow
        v-if="form.terminate"
        :form="form"
        name="termination_date"
        label="employee.termination.termination_date"
    >
        <DatePicker v-model="form.termination_date" />
    </InputRow> -->
</template>
